export const configDeviceList = {
    default: 'desktop',
    devices: [
        {
            id: 'desktop',
            name: 'Desktop',
            width: '',
            priority: 0,
        },
        {
            id: 'Tablet Horizontal',
            name: 'Tablet landscape',
            width: '993px',
            widthMedia: '1180px',
            priority: 1,
        },
        {
            id: 'tablet',
            name: 'Tablet',
            width: '770px',
            widthMedia: '992px',
            priority: 2,
        },
        {
            id: 'mobilePortrait',
            name: 'Mobile portrait',
            width: '400px',
            widthMedia: '480px',
            priority: 3,
        },
    ],
};